import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { EcommerceGenericoService } from 'projects/ecommerce-generico/src/public-api';
import { AuthService } from '../../../ecommerce-generico/src/lib/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  private obligaLogin: boolean = false;
  constructor(private serv: EcommerceGenericoService, private router: Router, private httpClient: HttpClient, private authService: AuthService) {

  }

  private async loadConfig() {
    try {
      const config: any = await this.httpClient.get('../cfg/app-configs.json').toPromise();
      this.obligaLogin = config?.obligaLogin || false;
    } catch (error) {
      console.error('Error al cargar la configuración', error);
      this.obligaLogin = false;
    }
  }

  async canActivate(): Promise<boolean> {
    if (this.authService.isLogueado())
      return true;
    await this.loadConfig();

    if (this.obligaLogin) {
      this.router.navigate(['/login']);
      return false;
    }
    return true;
  }
}


